<template>
  <v-card class="card-content-container">
    <v-card-title class="d-flex justify-center">{{ mode }}</v-card-title>
    <v-form
      @submit.prevent="submitForm"
      ref="form"
      v-model="valid"
      style="max-width: 1500px"
      class="mx-auto pa-4"
    >
      <v-alert
        dense
        v-if="error"
        color="red"
        elevation="5"
        outlined
        text
        type="error"
        align="center"
        class="mx-1"
      >
        {{ alertValidate }}
      </v-alert>

      <div v-for="(input, i) in inputsForm" :key="'input_' + i + input.name">
        <v-text-field
          :name="input.name"
          v-model="input.data"
          :type="input.type"
          :label="input.label"
          :rules="input.rules"
          outlined
          dense
        />
      </div>
      <div
        v-for="(input, i) in scheduleInputs"
        :key="'input_' + i + input.name"
      >
        <v-text-field
          :name="input.name"
          v-model="input.data"
          maxlength="5"
          :label="input.label"
          :rules="input.rules"
          @input="formatedHour(input)"
          outlined
          dense
        />
      </div>
      <div v-for="(select, index) in selects" :key="index">
        <v-select
          v-model="select.data"
          :name="select.name"
          :items="select.items"
          :item-text="select.itemsText"
          :item-value="select.itemsValue"
          :label="select.label"
          :rules="select.rules"
          :multiple="multiple"
          outlined
          dense
        />
      </div>

      <div v-if="modo === 'Editar'" class="mx-n2">
        <table-with-search
          :items="editToDistributionRules"
          :title="title"
          :headers="allHeaders"
          :openDialog="openDialogRelation"
          @headersUpdated="updateHeaders"
          class="mb-5"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <div class="d-flex justify-space-between">
        <v-btn class="bt-exit" @click="cancel">{{
          $tc("editRegistrations.cancel")
        }}</v-btn>
        <v-btn type="submit" class="bt-acept">
          {{ $tc("editRegistrations.acept") }}</v-btn
        >
      </div>
    </v-form>
    <v-dialog
      v-model="openRelation"
      :max-width="'600px'"
      persistent
      @keydown.esc="reset(false)"
    >
      <Form
        :itemsSelect="selectsData"
        :itemsHours="dataInputsHours"
        :items="dataInputs"
        @save="save"
        @cancel="reset"
        :maxWidth="'600px'"
        :show="true"
        :mode="modeConcept"
        :itemsCheckbox="dataCheckboxes"
        @changeCheckbox="updateDataCheck"
      />
    </v-dialog>
    <DeleteDialogRelation
      :showDialog="openDeleteRelation"
      :title="titleDelete"
      :confirmDelete="deleteItem"
      :cancelDelete="cancelDelete"
      :maxWidth="'290px'"
    />
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-card>
</template>
<script>
import DeleteDialogRelation from "@/components/Complement/DeleteDialog.vue";
import costCenters from "@/store/centrosDeCosto/costCenters";
import concepts from "@/store/conceptos/concepts";
import date from "@/store/common/date";
import DateWithCheck from "@/components/Complement/DateWithCheck.vue";
import Form from "@/components/Complement/Form.vue";
import Vue from "vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import salaryConcepts from "@/store/conceptosDeSueldos/salaryConcepts";
import rulesLiquidation from "@/store/modelosDeLiquidacion/rulesLiquidation";
import Detail from "@/models/reglasDeLiquidacion/detail.js";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    DateWithCheck,
    Date,
    Form,
    TableWithSearch,
    DeleteDialogRelation,
    Snackbar,
  },
  props: {
    items: {
      type: Array,
    },
    maxWidth: String,
    mode: String,
    itemsSelect: Array,
    show: {
      type: Boolean,
      default: false,
    },
    itemsSlider: Array,
    showDate: Boolean,
    showCheck: Boolean,
    multiple: Boolean,
    itemsCheckbox: Array,
    itemsHours: Array,
  },
  data() {
    return {
      restoValue: false,
      inputsForm: [],
      valid: true,
      error: false,
      alertValidate: "",
      selects: [],
      scheduleInputs: [],
      inputSlider: [],
      checkboxes: [],
      title: this.$tc("rulesDistribution.details"),
      titleTable: "reglasDeDistribucion_y_Relaciones",
      oldItems: {},
      titleDelete: this.$tc("rulesDistribution.toDetail"),
      dataInputs: [
        {
          name: "order",
          label: "Orden",
          data: "",
          type: "Number",
          rules: [
            (v) => !!v || this.$tc("validation.required"),
            (v) => v >= 1 || this.$tc("validation.greaterThanZero"),
            (v) =>
              v < 10000000 || `${this.$t("validation.maxDigits", { max: 7 })}`,
          ],
        },
      ],
      dataInputsHours: [
        {
          name: "maximo",
          label: "Ingresa cantidad de horas (hh:mm)",
          data: "",
          rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
        },
      ],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      dataCheckboxes: [
        {
          name: "resto",
          label: this.$tc("settlementRules.rest"),
          data: false,
        },
      ],
    };
  },

  mounted() {
    this.checkboxes = Vue.observable(this.itemsCheckbox);
    this.inputsForm = Vue.observable(this.items);
    this.selects = Vue.observable(this.itemsSelect);
    this.inputSlider = Vue.observable(this.itemsSlider);
    this.scheduleInputs = Vue.observable(this.itemsHours);
  },
  computed: {
    allHeaders() {
      return configTable.state.colums.detalles;
    },
    modo() {
      if (this.mode === this.$tc("rulesDistribution.addDistribution")) {
        return this.$tc("commons.add");
      } else {
        return this.$tc("commons.edit");
      }
    },
    modeConcept: {
      get() {
        return salaryConcepts.state.modeRelation;
      },
      set(newValue) {
        return newValue;
      },
    },
    concepts() {
      return concepts.state.concepts;
    },
    costCenters() {
      return costCenters.state.costCenters;
    },
    openRelation: {
      get() {
        return salaryConcepts.state.openRelation;
      },
      set(newvalue) {
        return newvalue;
      },
    },

    openDeleteRelation: {
      get() {
        return salaryConcepts.state.openDeleteRelation;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    clocks() {
      return clocks.state.clocks;
    },
    concepts() {
      return concepts.state.concepts;
    },
    selectsData() {
      return [
        {
          name: "conceptId",
          label: this.$tc("rulesDistribution.concept"),
          data: [],
          items: this.concepts,
          itemsValue: "id",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
        },
        {
          name: "csCostId",
          label: this.$tc("rulesDistribution.csCosts"),
          data: [],
          items: this.costCenters,
          itemsValue: "id",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
        },
      ];
    },

    editToDistributionRules() {
      return rulesLiquidation.state.edit.reglasLiqD.map((item) => {
        return Detail.fromJson(item);
      });
    },
  },
  watch: {
    restoValue(newRestoValue) {
      if (newRestoValue === true) {
        this.dataInputsHours[0].readonly = true;
        this.dataInputsHours[0].data = "00:00";
      } else {
        this.dataInputsHours[0].readonly = false;
        this.dataInputsHours[0].data = "08:00";
      }
    },
  },

  methods: {
    forceForm() {
      this.$emit("force-form");
    },
    async refreshItems() {
      if (rulesLiquidation.state.edit.reglaLiqId) {
        await rulesLiquidation.dispatch(
          "refreshTable",
          rulesLiquidation.state.edit.reglaLiqId
        );
      }
      this.forceForm();
    },
    updateHeaders(headers) {
      const updatedColums = { ...configTable.state.colums, detalles: headers };
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (columnsToSave === undefined || this.allHeaders.length !== this.headers.length  || columnsToSave.length === 0) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    openEditForm(item) {
      this.dataInputs[0].data = item.orden;
      this.selectsData[0].data = item.conceptId;
      this.selectsData[1].data = item.cscostoId;
      let maximo = this.convertToHours(item.maximo);
      this.dataInputsHours[0].data = maximo;
      this.dataCheckboxes[0].data = item.resto;
      this.selectsData[0].readonly = true;
      this.selectsData[1].readonly = true;
      salaryConcepts.commit("setOpenRelation", true);
    },

    updateDataCheck(a) {
      this.restoValue = a.resto;
    },

    submitForm(e) {
      e.preventDefault();
      this.validation(e.target);
    },

    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    resetDate() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },

    reset() {
      this.resetDate();
      salaryConcepts.commit("setModeRelation", "");
      salaryConcepts.commit("setOpenRelation", false);
      this.selectsData.forEach((item) => {
        item.data = "";
      });
      this.dataInputsHours.forEach((item) => {
        item.data = "";
      });
      this.dataInputs.forEach((item) => {
        item.data = "";
      });
      this.dataCheckboxes.forEach((item) => {
        item.data = "";
      });
    },

    save(items) {
      switch (this.typeForm) {
        case "add":
          this.addRuleDistribution(items);
          break;
        case "edit":
          this.editRuleDistribution(items);
          break;
        default:
          break;
      }
    },

    addRuleDistribution(items) {
      let payload = items;
      payload.reglaLiqId = rulesLiquidation.state.edit.reglaLiqId;
      if (payload.maximo) {
        payload.maximo = this.convertToMinutes(payload.maximo);
      }
      payload.resto = payload.resto === "true";

      rulesLiquidation.commit("setNew", payload);
      rulesLiquidation
        .dispatch("addRuleDistribution")
        .then(() => {
          salaryConcepts.commit("setOpenRelation", false);
          this.showAlert(
            this.$tc("rulesDistribution.addDetailSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.message, "#ff8d58");
        });
      this.reset(false);
    },
    sendEdit(updatedItem) {
      costCenters.commit("setEditClock", updatedItem);

      costCenters
        .dispatch("editClock")
        .then(() => {
          costCenters.commit("setOpenRelation", false);
          this.showAlert(this.$tc("costCenter.editClockSuccess"), "#82A1D0");
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.message, "#ff8d58");
        });

      this.reset(false);
    },

    editRuleDistribution(form) {
      let payload = this.detectChanges(form);
      if (Object.keys(payload).length > 0) {
        payload.reglaliqid = rulesLiquidation.state.edit.reglaLiqId;
        payload.oldItems = this.oldItems;
        rulesLiquidation.commit("setEditRelation", payload);
        rulesLiquidation
          .dispatch("editRuleDistribution")
          .then(() => {
            rulesLiquidation.dispatch("refreshTable", payload.reglaliqid);
            this.forceForm();
            this.showAlert(
              this.$tc("rulesDistribution.editDetailSuccess"),
              "#82A1D0"
            );
          })
          .catch((e) => {
            this.showAlert(e.response.data.error.message, "#ff8d58");
          });
      } else {
        this.showAlert(this.$tc("validation.noEditsMessage"), "#F7DC6F");
      }

      this.reset(false);
    },

    detectChanges(newItems) {
      newItems.maximo = this.convertToMinutes(newItems.maximo);
      newItems.resto = newItems.resto === "true";
      const changes = {};
      const oldItem = this.oldItems;

      if (oldItem) {
        if (oldItem.orden != Number(newItems.order)) {
          changes.num = Number(newItems.order);
        }
        if (oldItem.maximo !== newItems.maximo) {
          changes.maximo = newItems.maximo;
        }
        if (oldItem.resto !== newItems.resto) {
          changes.resto = newItems.resto;
        }
      }
      return changes;
    },

    handleSubmit(form) {
      const formData = new FormData(form);
      const itemsComplete = {};

      for (let [name, value] of formData) {
        itemsComplete[name] = value;
      }
      this.$refs.form.resetValidation();

      this.$emit("save", itemsComplete);
    },
    cancel() {
      this.$refs.form.resetValidation();

      this.$emit("cancel", false);
    },
    validation(form) {
      let valid = this.$refs.form.validate();
      if (valid) {
        this.handleSubmit(form);
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },

    handleChange(i) {
      console.log(i);
    },
    async openDialogRelation(type, item) {
      this.typeForm = type;
      switch (this.typeForm) {
        case "add":
          this.selectsData[0].readonly = false;
          this.selectsData[1].readonly = false;

          await salaryConcepts.commit(
            "setModeRelation",
            this.$tc("rulesDistribution.addDetail")
          );
          salaryConcepts.commit("setOpenRelation", true);
          break;
        case "edit":
          this.oldItems = item;
          await salaryConcepts.commit(
            "setModeRelation",
            this.$tc("rulesDistribution.editDetail")
          );
          await this.openEditForm(item);

          break;
        case "delete":
          salaryConcepts.commit("setOpenDeleteRelation", true);
          this.itemToDelete = item;
          this.itemToDelete.reglaliqid = rulesLiquidation.state.edit.reglaLiqId;
          break;

        default:
          break;
      }
    },
    convertToMinutes(value, dayValue) {
      const [hours, minutes] = value.split(":");
      const hoursInt = parseInt(hours, 10);
      const minutesInt = parseInt(minutes, 10);
      let totalMinutes = hoursInt * 60 + minutesInt;
      if (dayValue === "0") {
        totalMinutes -= 1440;
      } else if (dayValue === "2") {
        totalMinutes += 1440;
      }
      return totalMinutes;
    },
    convertToHours(minutos) {
      if (typeof minutos !== "number" || minutos < 0) {
        return "Invalido";
      }

      const horas = Math.floor(minutos / 60);
      const minutosRestantes = minutos % 60;

      const horasFormateadas = horas.toString().padStart(2, "0");
      const minutosFormateados = minutosRestantes.toString().padStart(2, "0");

      return horasFormateadas + ":" + minutosFormateados;
    },
    deleteItem() {
      rulesLiquidation.commit("setItemDelete", this.itemToDelete);
      rulesLiquidation
        .dispatch("deleteRuleDistribution")
        .then(() => {
          salaryConcepts.commit("setOpenDeleteRelation", false);
          this.showAlert(
            this.$tc("rulesDistribution.deleteDetailSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert("salariesConcepts.errorConceptToSalary", "#ff8d58");
        });
    },

    cancelDelete() {
      this.openDelete = false;
      salaryConcepts.commit("setOpenDeleteRelation", false);
    },
    formatedHour(input) {
      let data = input.data;
      if (data === "") {
      } else if (!/^[0-9:]+$/.test(data)) {
        data = "00:00";
      } else {
        data = data.replace(/[^\d:]/g, "");
        if (data.length >= 2 && data.indexOf(":") === -1) {
          data = data.substring(0, 2) + ":" + data.substring(2);
        }

        data = data.substring(0, 5);

        const [horas, minutos] = data.split(":").map(Number);

        if (!isNaN(minutos) && minutos > 59) {
          data = `${horas}:59`;
        }

        if (!isNaN(horas) && horas > 24) {
          data = "24:00";
        }
      }

      input.data = data;
    },
  },
};
</script>

<style scoped>
.slider-input {
  display: flex !important;
  justify-content: center !important;
  align-items: flex-end !important;
}

.slider-container {
  border: 1px solid #959595;
  margin-bottom: 30px;
  height: 110px;
}

.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}

.card-content-container {
  max-width: 1500px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
